import Link from 'next/link'
import React from 'react'
import PropTypes from 'prop-types'

const CustomButton = (props) => {

    const {
        href = "",
        label,
        shouldRenderArrow = true,
        variant = "outlined",
        className,
        ...rest
    } = props

    const VARIANT_ONE = " hover:bg-[#EB532E] hover:border-[#EB532E] hover:text-white"

    const VARIANT_TWO = " bg-[#35343A] text-white hover:bg-[#EB532E] hover:border-[#EB532E]"

    return (
        <Link
            {...rest}
            aria-label='custom-button'
            href={href}
            className={`group relative uppercase border-2 border-black text-[0.9rem] sm:text-[12px] font-semibold pl-6 ${shouldRenderArrow ? 'pr-12' : 'pr-6'} py-3 pt-4 transition-all rounded-full  border-opacity-50 flex items-center duration-300 ${variant === "outlined" ? VARIANT_ONE : VARIANT_TWO} ${className || ''}`}
        >
            <p className='line-clamp-1 font-black fw-7 text-ellipsis overflow-hidden'>{label}</p>
            {shouldRenderArrow ?
                <span className="absolute top-1/2 mt-[-10px] right-5">
                    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-[#EB532E] group-hover:fill-white transition-all duration-300">
                        <path d="M0.862061 0.5L6.20061 9.41559L0.862061 18.3588H4.12441L9.37854 9.41559L4.12441 0.5H0.862061Z"></path>
                        <path d="M6.46777 0.5L11.8063 9.41559L6.46777 18.3588H9.73012L14.9843 9.41559L9.73012 0.5H6.46777Z"></path>
                    </svg>
                </span> : null
            }
        </Link>
    )
}

CustomButton.propTypes = {
    href: PropTypes.string,
    label: PropTypes.string.isRequired,
    shouldRenderArrow: PropTypes.bool,
    // backgroundColor: PropTypes.string,
    // hoverBackgroundColor: PropTypes.string,
    // hoverBorderColor: PropTypes.string,
    // borderColor: PropTypes.string,
    className: PropTypes.string,
    variant: PropTypes.oneOf(["fill", "outlined"])

}

export default CustomButton